import {onready} from './app.js';

onready();